import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'image-and-text',
  templateUrl: 'image-and-text.html'
})
export class ImageAndTextComponent {
  
  @Input() img : string;
  @Input() text : string;
  @Input() bigIcons: boolean;
  
  constructor(public translate: TranslateService) {}
}



// WEBPACK FOOTER //
// ./src/components/myria/layouts/two-columns/image-and-text/image-and-text.ts